import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

export class ContratoDetalheAditivo extends Component {
  static propTypes = {
    aditivos: PropTypes.object.isRequired,
    onDownload: PropTypes.func.isRequired
  };

  onViewDetalhes = aditivo => {
    const { history } = this.props;
    const entidade = aditivo.get('entidade');
    const exercicio = aditivo.get('exercicio');
    const numero = aditivo.get('numero');
    const sequencia = aditivo.get('sequencia');

    history.push(
      `/aditivos/detalhes?entidade=${entidade}&exercicio=${exercicio}&numero=${numero}&sequencia=${sequencia}`
    );
  };

  renderAditivos = data => {
    const key =
      data.get('entidade') +
      '_' +
      data.get('exercicio') +
      '_' +
      data.get('numero') +
      '_' +
      data.get('sequencia');

    return (
      <TableActions
        ref="row"
        key={key}
        data={data}
        onMore={this.onViewDetalhes}
      >
        <td>{data.get('numeroAditivo')}</td>
        <td>{DateUtils.transform(data.get('data'))}</td>
        <td>{DateUtils.transform(data.get('dataPublicacao'))}</td>
        <td>
          <NumberFormatter value={data.get('valorAditivo')} />
        </td>
        <td>{DateUtils.transform(data.get('dataTermino'))}</td>
        <td>{data.get('motivacao')}</td>
      </TableActions>
    );
  };

  render() {
    const { aditivos } = this.props;

    return (
      <div className="hidden-print">
        <section>
          <Panel title="Aditivos" isTable tableResponsive>
            <div className="panel-table-outer">
              <table className="panel-table striped fancy">
                <TableHeader
                  empty={aditivos.isEmpty()}
                  text="Sem aditivos para este contrato."
                >
                  <tr>
                    <th>N° Aditivo</th>
                    <th>Data</th>
                    <th>Publicação</th>
                    <th>Valor Aditivos</th>
                    <th>Término</th>
                    <th>Motivação</th>
                    <th></th>
                  </tr>
                </TableHeader>
                <tbody>{aditivos.map(this.renderAditivos)}</tbody>
              </table>
            </div>
          </Panel>
        </section>
      </div>
    );
  }
}

export default ContratoDetalheAditivo;
